import Head from 'next/head'
import type { FC } from 'react'
import { Container } from 'components/ui'
import Layout, { Breadcrumb, BreadcrumbProps } from 'components/layout'
import { PostSection } from 'modules/posts/components'
import s from './blog.module.css'

interface SellersProps {}

const Sellers: FC<SellersProps> = () => {
  const crumbs: BreadcrumbProps['crumbs'] = [{ url: '/', label: 'Blog' }]

  return (
    <Layout>
      <Head>
        <title>Blog</title>
      </Head>
      <Breadcrumb crumbs={crumbs} />
      <Container className={s.root}>
        <PostSection ignore="" limit={15} />
      </Container>
    </Layout>
  )
}

export default Sellers
